import { useAuth } from "@/contexts/AuthContext";
import { useUserService } from "@/hooks/useUserService";
import { useCallback } from "react";

type DeleteFirmUserFn = (userId: string) => Promise<void>;

export const useDeleteFirmUser = (): { deleteFirmUser: DeleteFirmUserFn } => {
  const usersService = useUserService();
  const { firmContext } = useAuth();
  const firmId = firmContext?.firmId;

  const deleteFirmUser = useCallback(
    async (userId: string): Promise<void> => {
      if (!firmId) {
        throw new Error("No firm context available");
      }
      await usersService.deleteFirmUser(firmId, userId);
    },
    [usersService, firmId]
  );

  return { deleteFirmUser };
};
